import React from 'react'

import { ZariContext } from '_zari/context'
import { Col, Row, Portlet, Button } from '_zari/core'

import { MesesContabilidadConstant } from 'constants/index'

import { DownloadAxiosFile } from 'utils'

import * as AsientosContablesServices from 'services/asientosContables.service'

import * as FormGroups from './formGroups'

const EstadoFinanciero = () => {
  const __zariContext = React.useContext(ZariContext)

  const [mesSeleccionado, setMesSeleccionado] = React.useState(MesesContabilidadConstant.APERTURA)
  const [anioSeleccionado, setAnioSeleccionado] = React.useState(new Date().getFullYear())
  const [clienteSeleccionado, setClienteSeleccionado] = React.useState(null)

  const clickDescargarReporteEF = React.useCallback(() => {
    if (clienteSeleccionado) {
      const idCliente = clienteSeleccionado._id
      __zariContext.loader.open('Descargando reporte estados financieros')
      AsientosContablesServices.descargarReporteEstadosFinancieros({ clienteSeleccionado: idCliente, anioSeleccionado, mesSeleccionado })
        .then(({ data, headers }) => {
          DownloadAxiosFile.downloadAsBlob(data, headers)
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
        })
        .finally(() => {
          __zariContext.loader.close()
        })
    } else {
      __zariContext.snack('error', 'El campo Cliente es requerido')
    }
  }, [clienteSeleccionado, mesSeleccionado, anioSeleccionado, __zariContext])

  return (
    <Portlet className='zari-slim-form'>
      <Portlet.Header title='Reporte Estados Financieros' />
      <Portlet.Body>
        <Row>
          <Col md={10}>
            <FormGroups.AnioFormGroup anioSeleccionado={anioSeleccionado} setAnioSeleccionado={setAnioSeleccionado} />
          </Col>
        </Row>
        <Row>
          <Col md={10}>
            <FormGroups.MesFormGroup mesSeleccionado={mesSeleccionado} setMesSeleccionado={setMesSeleccionado} />
          </Col>
        </Row>
        <Row>
          <Col md={10}>
            <FormGroups.ClienteFormGroup clienteSeleccionado={clienteSeleccionado} setClienteSeleccionado={setClienteSeleccionado} />
          </Col>
        </Row>
        <Row>
          <Col md={12} className='text-right'>
            <Button onClick={clickDescargarReporteEF}>Descargar Reporte</Button>
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(EstadoFinanciero)
